/**
 * @fileoverview Mailbox handle client-side validation (MOR-783)
 *
 * Split out of `EnableMailboxCard.tsx` (react-refresh/only-export-components)
 * — mirrors `convex/mail/handleRules.ts` (server re-validates).
 */

const HANDLE_RE = /^[a-z0-9](?:[a-z0-9-]{1,28}[a-z0-9])?$/;

export function validateHandleClient(handle: string): string | null {
  if (handle.length < 3 || handle.length > 30) {
    return "The address must be 3 to 30 characters long";
  }
  if (!HANDLE_RE.test(handle)) {
    return "Use lowercase letters, numbers, and hyphens only (no leading or trailing hyphen)";
  }
  return null;
}
